<p>base-authenticated works!</p>
